import { render } from "./SafaricomTerms.vue?vue&type=template&id=de30ba14&scoped=true"
import script from "./SafaricomTerms.vue?vue&type=script&lang=js"
export * from "./SafaricomTerms.vue?vue&type=script&lang=js"

import "./SafaricomTerms.vue?vue&type=style&index=0&id=de30ba14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de30ba14"]])

export default __exports__